import { ApiService } from "./ApiService.js";
import { ServiceConsts } from "./ServiceConsts.js";

export class UserService {
    static questionnaireDone = async (userId) => {
        let data = {
            questionnaireDone: true,
        };
        return ApiService.patch(
            `${ServiceConsts.API_URL}/users/${userId}`,
            data,
        );
    };

    static async usernameExists(username) {
        return ApiService.get(
            `${ServiceConsts.API_URL}/users/usernameExists?username=${encodeURIComponent(username)}`,
        );
    }

    static async getMyPersonalTenant() {
        return ApiService.get(`${ServiceConsts.API_URL}/users/me/tenant`);
    }

    static async getSlackWorkspaces() {
        return ApiService.get(
            `${ServiceConsts.API_URL}/users/slack/workspaces`,
        );
    }

    static async syncSlackWorkspace(workspaceId) {
        return ApiService.get(
            `${ServiceConsts.API_URL}/slack/workspace/${workspaceId}/sync`,
        );
    }

    static async updateUser(user){
        const data = {
            firstName: user.firstName,
            lastName: user.lastName,
        };
        return ApiService.patch(
            `${ServiceConsts.API_URL}/users/${user.id}`,
            data,
        );
    };

    static resetPassword = async () => {
        return ApiService.post(
            `${ServiceConsts.API_URL}/users/password/reset`,
            {},
        );
    };

    static deleteAccount = async (password) => {
        return ApiService.delete(`${ServiceConsts.API_URL}/users/me`, {
            password,
        });
    };

    static async saveUserMetadata(metadata) {
        const updatedMetadata = {
            ...metadata,
            firstUserAgent: navigator.userAgent,
            lastUserAgent: navigator.userAgent 
        };

        return ApiService.post(
            `${ServiceConsts.API_URL}/users/metadata`,
            updatedMetadata,
        );
    }
}
